module.exports = __webpack_public_path__ + "static/media/SAC-Energy-Outlined-white-rotated-dark.9d23235d.png";